import { AxiosResponseHeaders } from "axios";
import saveAs from "file-saver";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useDownloadInvoiceToExcelMutation } from "../../../api/services/client/clientApis";
import { toggleLoader } from "../../../redux/slices/appState/appStateSlice";
import { getFileNameFromHeader } from "../../reports/helper";

export const useDownloadInvoiceToExcel = () => {
  const dispatch = useDispatch();
  const {
    mutateAsync: downloadInvoiceToExcel,
    isPending: isDownloadInvoicePending,
  } = useDownloadInvoiceToExcelMutation();

  useEffect(() => {
    dispatch(
      toggleLoader({
        isDownloadInvoiceToExcelPending: {
          isVisible: isDownloadInvoicePending,
        },
      }),
    );
    return () => {
      dispatch(
        toggleLoader({ isDownloadInvoiceToExcelPending: { isVisible: false } }),
      );
    };
  }, [isDownloadInvoicePending]);

  const downloadInvoiceExcel = async (
    invoiceId: string,
    deliverableFrameworkType:  string,
  ) => {
    const response = await downloadInvoiceToExcel({
      invoiceId,
      deliverableFrameworkType,
    });

    const filename = getFileNameFromHeader(
      response.headers as AxiosResponseHeaders,
    );
    saveAs(response.data, filename);
  };

  return {
    downloadInvoiceExcel,
  };
};
